import useContext from "../../../context";

const dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  trailingZeroDisplay: 'stripIfInteger',
});

export default function PurchasePrice() {
  const [context] = useContext();

  return (
    <div className="quoteform__text" id="purchase-price">Purchase Price of Contract: {dollars.format(context.response.noCreditCheck.purchase_price || 0)}</div>
  );
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/PurchasePrice.js